module.exports = __webpack_public_path__ + "img/skin-2@2x.5c9c5556.png";